var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOffline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_offline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9,3 C12.3137085,3 15,5.6862915 15,9 C15,12.3137085 12.3137085,15 9,15 C5.6862915,15 3,12.3137085 3,9 C3,5.6862915 5.6862915,3 9,3 Z M12.7625819,6.23890191 L6.23789745,12.7618433 C7.01125325,13.3306292 7.96638375,13.6666667 9,13.6666667 C11.5773288,13.6666667 13.6666667,11.5773288 13.6666667,9 C13.6666667,7.9668312 13.3309201,7.01208021 12.7625819,6.23890191 Z M9,4.33333333 C6.42267117,4.33333333 4.33333333,6.42267117 4.33333333,9 C4.33333333,9.947522 4.61572222,10.8290885 5.10093102,11.5651306 L11.5651306,5.10093102 C10.8290885,4.61572222 9.947522,4.33333333 9,4.33333333 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,3 C12.3137085,3 15,5.6862915 15,9 C15,12.3137085 12.3137085,15 9,15 C5.6862915,15 3,12.3137085 3,9 C3,5.6862915 5.6862915,3 9,3 Z M12.7625819,6.23890191 L6.23789745,12.7618433 C7.01125325,13.3306292 7.96638375,13.6666667 9,13.6666667 C11.5773288,13.6666667 13.6666667,11.5773288 13.6666667,9 C13.6666667,7.9668312 13.3309201,7.01208021 12.7625819,6.23890191 Z M9,4.33333333 C6.42267117,4.33333333 4.33333333,6.42267117 4.33333333,9 C4.33333333,9.947522 4.61572222,10.8290885 5.10093102,11.5651306 L11.5651306,5.10093102 C10.8290885,4.61572222 9.947522,4.33333333 9,4.33333333 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_offline",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18-Copy-5",
    fill: "#F2F2F2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    rx: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape-Copy-2",
    fill: "#C60000",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape-Copy-2",
    fill: "#C60000",
    xlinkHref: "#path-3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOffline);
export default __webpack_public_path__ + "static/media/icon_offline.7811a8bd0cffd2707eb651a2310ee1d7.svg";
export { ForwardRef as ReactComponent };